import PropTypes from "prop-types";
export const CALENDAR_PROVIDERS = {
    google: "google",
    outlookLive: "outlook",
    office365: "office365",
    yahoo: "yahoo",
    apple: "apple",
};
export const CalendarProviderPropTypes = PropTypes.oneOf(Object.values(CALENDAR_PROVIDERS));
//# sourceMappingURL=AddToCalendarPropTypes.js.map